<div class="mb-8 flex items-center justify-between">
  <h1 class="flex h-11 items-center text-2xl font-bold text-aux-gray-darkest">Account Profile</h1>
</div>

<div>
  <div class="mb-8">
    <aux-route-tab-group [tabs]="tabs" />
  </div>

  <router-outlet />
</div>
